import { IGameData } from 'js/bubbleCore/types';
import { IHexPixelSize } from 'js/bubbleCore/view/types';
import { convertHexLimitsToSpaceLimits } from 'js/bubbleCore/utils/convertHexLimitsToSpaceLimits';
import { convertRectangleToSpace } from 'js/bubbleCore/utils/convertRectangleToSpace';
import { spacePositionToPxPosition } from 'js/bubbleCore/view/utils/spacePositionToPxPosition';
import { getHexSize } from 'js/bubbleCore/utils/getHexSize';
import { IRectangle } from 'framework/utils/math-utils';

export function getWholeBoardPixelSize(data: IGameData, size: IHexPixelSize): IRectangle {
  const hexSize = getHexSize(data.grid.type);
  const hexLimits = data.grid.limits;

  // to cover board edge to edge (as 0x0 is center of hex)
  const outerLimits = convertHexLimitsToSpaceLimits({
    x: hexLimits.x - hexSize.width * 0.5,
    y: hexLimits.y - hexSize.height * 0.5,
    width: hexLimits.width + 0.5,
    height: hexLimits.height + 0.5,
  }, data.grid.type);

  const {x: left, y: top} = spacePositionToPxPosition(
    outerLimits.x, outerLimits.y, size
  );

  const {x: rigth, y: bottom} = spacePositionToPxPosition(
    outerLimits.width, outerLimits.height, size
  );

  return {
    x: left,
    y: top,
    width: rigth - left,
    height: bottom - top,
  }
} 